import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2"; // <<<<<<<<<<<<<<<<<<<<< ADD THIS LINE
import DashNavbar from "./DashNavbar";
import Sidebar from "./Sidebar";
import Pagination from "react-bootstrap/Pagination";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button"; // For Modal footer
import { FcCancel, FcApproval } from "react-icons/fc";
import { IoWarningOutline } from "react-icons/io5";
import Spinner from "react-bootstrap/Spinner";
import { FaEye, FaCheckCircle, FaTimesCircle, FaSearch } from "react-icons/fa"; // More icons


function DocumentViewList() {
  const [documents, setDocuments] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredDocuments, setFilteredDocuments] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const itemsPerPage = 5;
  const [isLoading, setIsLoading] = useState(false);
  const [viewLoading, setViewLoading] = useState({}); // For individual PDF view buttons
  const [buttonLoading, setButtonLoading] = useState({}); // For accept/reject buttons

  // Define document types for the modal, including new ones
  const documentTypesConfig = [
    { key: "aadhar", label: "Aadhar Card" },
    { key: "pan", label: "PAN Card" },
    { key: "hsc", label: "HSC Mark Sheet" },
    { key: "ssc", label: "SSC Mark Sheet" },
    { key: "degree", label: "UG Certificate/Mark Sheet" },
    { key: "other", label: "PG Certificate/Mark Sheet" },
    { key: "passport_photo", label: "Passport Photo" },
    { key: "driving_licence", label: "Driving Licence" },
    { key: "cheque_photo", label: "Cheque Photo" },
    { key: "experience_letter", label: "Experience Letter" },
  ];

  useEffect(() => {
    fetchDocuments();
  }, []); // Fetch on mount

  useEffect(() => {
    filterDocuments(documents);
  }, [searchTerm, documents, currentPage]); // Re-filter when search or documents change


  const fetchDocuments = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(
        `https://raasbackend.vetrinahealthcare.com/api/documents/`
      );
      setDocuments(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
      setDocuments([]);
    } finally {
      setIsLoading(false);
    }
  };

  const filterDocuments = (data) => {
    const filtered = data.filter(
      (document) =>
        document.username.toLowerCase().includes(searchTerm.toLowerCase()) ||
        document.email.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredDocuments(filtered);
    if (currentPage > Math.ceil(filtered.length / itemsPerPage) && filtered.length > 0) {
        setCurrentPage(1);
    } else if (filtered.length === 0) {
        setCurrentPage(1);
    }
  };

  const handlePageChange = (page) => {
    const totalPages = Math.ceil(filteredDocuments.length / itemsPerPage);
    if (page < 1 || page > totalPages) {
      if (totalPages === 0 && page ===1) {
      } else {
        return;
      }
    }
    setCurrentPage(page);
  };

  const totalPages = Math.max(1, Math.ceil(filteredDocuments.length / itemsPerPage));
  const paginatedDocuments = filteredDocuments.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleViewDetails = (document) => {
    setSelectedDocument(document);
  };

  const handleCloseDetails = () => {
    setSelectedDocument(null);
    setViewLoading({});
    setButtonLoading({});
  };

  const handleOpenDocument = async (documentType) => {
    if (!selectedDocument || !selectedDocument.email) return;
    setViewLoading((prev) => ({ ...prev, [documentType]: true }));
    try {
      const response = await axios.post(
        "https://raasbackend.vetrinahealthcare.com/api/view_document/",
        { email: selectedDocument.email, document_type: documentType },
        { responseType: "blob" }
      );
      
      const contentType = response.headers['content-type'];
      const blob = new Blob([response.data], { type: contentType || 'application/octet-stream' });
      const url = window.URL.createObjectURL(blob);
      window.open(url, "_blank");
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error opening document:", error);
      Swal.fire({ // Now Swal is defined
        icon: "error",
        title: "View Failed",
        text: "Could not load the document. It might not be uploaded or an error occurred.",
      });
    } finally {
      setViewLoading((prev) => ({ ...prev, [documentType]: false }));
    }
  };

  const handleAcceptReject = async (documentType, status) => {
    if (!selectedDocument || !selectedDocument.email) return;
    const loadingKey = `${documentType}_${status}`;
    setButtonLoading((prev) => ({ ...prev, [loadingKey]: true, }));

    try {
      await axios.post(
        "https://raasbackend.vetrinahealthcare.com/api/update_document_status/",
        {
          email: selectedDocument.email,
          document_type: documentType,
          status: status,
        }
      );

      setSelectedDocument((prev) => ({
        ...prev,
        [`${documentType}_status`]: status,
      }));

      fetchDocuments(); 
      Swal.fire({ // Now Swal is defined
        icon: "success",
        title: `Document ${status === 'Y' ? 'Accepted' : 'Rejected'}`,
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
      });
    } catch (error) {
      console.error("Error updating status:", error);
      Swal.fire({ // Now Swal is defined
        icon: "error",
        title: "Update Failed",
        text: "Could not update document status.",
      });
    } finally {
      setButtonLoading((prev) => ({ ...prev, [loadingKey]: false, }));
    }
  };

  const iconStyle = { fontSize: "1.8em", verticalAlign: "middle" };

  return (
    <>
      <DashNavbar />
      <div className="wrapper">
        <Sidebar />
        <div className="main p-3 p-md-4">
          <div className="container-fluid">
            <div
              className="auth-inner mt-2 w-100 shadow-sm rounded"
              style={{ padding: "20px"}}
            >
              <h2 className="mb-4 gradient-text">Document Verification List</h2>
              <div className="row mb-3">
                <div className="col-md-6 offset-md-3">
                  <div className="input-group">
                    <input
                      type="search"
                      className="form-control"
                      placeholder="Search by Name or Email"
                      value={searchTerm}
                      onChange={handleSearchChange}
                      aria-label="Search"
                    />
                    <button className="btn btn-outline-primary" type="button">
                      <FaSearch />
                    </button>
                  </div>
                </div>
              </div>

              <div className="table-responsive">
                <table className="table table-hover align-middle">
                  <thead className="table-light">
                    <tr>
                      <th scope="col" style={{width: "5%"}}>Sr.No</th>
                      <th scope="col" style={{width: "30%"}}>Name</th>
                      <th scope="col" style={{width: "15%"}}>User ID</th>
                      <th scope="col" style={{width: "30%"}}>Email</th>
                      <th scope="col" style={{width: "20%"}} className="text-center">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {isLoading ? (
                      <tr>
                        <td colSpan="5" className="text-center py-5">
                          <Spinner animation="border" variant="primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </Spinner>
                          <p className="mt-2">Loading Documents...</p>
                        </td>
                      </tr>
                    ) : paginatedDocuments.length > 0 ? (
                      paginatedDocuments.map((document, index) => (
                        <tr key={document.id || index}>
                          <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                          <td>{document.username}</td>
                          <td>{document.user}</td>
                          <td>{document.email}</td>
                          <td className="text-center">
                            <Button
                              variant="primary"
                              size="sm"
                              onClick={() => handleViewDetails(document)}
                              title="View Document Details"
                            >
                              <FaEye className="me-1" /> View Details
                            </Button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="text-center py-4 text-muted">
                          No documents found matching your criteria.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {filteredDocuments.length > itemsPerPage && (
                <div className="d-flex justify-content-center mt-4">
                  <Pagination>
                    <Pagination.Prev
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                    />
                    {[...Array(totalPages).keys()].map((pageNumber) => (
                      <Pagination.Item
                        key={pageNumber + 1}
                        active={pageNumber + 1 === currentPage}
                        onClick={() => handlePageChange(pageNumber + 1)}
                      >
                        {pageNumber + 1}
                      </Pagination.Item>
                    ))}
                    <Pagination.Next
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages || totalPages === 0}
                    />
                  </Pagination>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {selectedDocument && (
        <Modal show={true} onHide={handleCloseDetails} size="xl" centered>
          <Modal.Header closeButton>
            <Modal.Title>
              Document Details: {selectedDocument.username} ({selectedDocument.email})
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className="mb-1"><strong>User ID:</strong> {selectedDocument.user}</p>
            <hr/>
            <div className="table-responsive">
            <table className="table table-striped table-bordered">
              <thead className="table-dark">
                <tr>
                  <th scope="col">Document Name</th>
                  <th scope="col" className="text-center">View PDF</th>
                  <th scope="col" className="text-center">Actions</th>
                  <th scope="col" className="text-center">Status</th>
                </tr>
              </thead>
              <tbody>
                {documentTypesConfig.map((docConfig) => (
                  <tr key={docConfig.key}>
                    <td className="fw-medium align-middle">{docConfig.label}</td>
                    <td className="text-center align-middle">
                      <Button
                        variant="outline-info"
                        size="sm"
                        onClick={() => handleOpenDocument(docConfig.key)}
                        disabled={!selectedDocument[docConfig.key] || viewLoading[docConfig.key]}
                        title={`View ${docConfig.label}`}
                      >
                        {viewLoading[docConfig.key] ? (
                          <Spinner animation="border" size="sm" />
                        ) : (
                          <><FaEye className="me-1" /> View</>
                        )}
                      </Button>
                    </td>
                    <td className="text-center align-middle">
                      <Button
                        variant="outline-success"
                        size="sm"
                        className="me-2"
                        onClick={() => handleAcceptReject(docConfig.key, "Y")}
                        disabled={!selectedDocument[docConfig.key] || buttonLoading[`${docConfig.key}_Y`] || selectedDocument[`${docConfig.key}_status`] === 'Y'}
                        title={`Accept ${docConfig.label}`}
                      >
                        {buttonLoading[`${docConfig.key}_Y`] ? (
                          <Spinner animation="border" size="sm" />
                        ) : (
                          <><FaCheckCircle className="me-1"/> Accept</>
                        )}
                      </Button>
                      <Button
                        variant="outline-danger"
                        size="sm"
                        onClick={() => handleAcceptReject(docConfig.key, "N")}
                        disabled={!selectedDocument[docConfig.key] || buttonLoading[`${docConfig.key}_N`] || selectedDocument[`${docConfig.key}_status`] === 'N'}
                        title={`Reject ${docConfig.label}`}
                      >
                        {buttonLoading[`${docConfig.key}_N`] ? (
                          <Spinner animation="border" size="sm" />
                        ) : (
                          <><FaTimesCircle className="me-1"/> Reject</>
                        )}
                      </Button>
                    </td>
                    <td className="text-center align-middle">
                      {selectedDocument[`${docConfig.key}_status`] === "Y" && (
                        <FcApproval style={iconStyle} title="Approved" />
                      )}
                      {selectedDocument[`${docConfig.key}_status`] === "N" && (
                        <FcCancel style={iconStyle} title="Rejected" />
                      )}
                      {(!selectedDocument[`${docConfig.key}_status`]) && (
                        <IoWarningOutline style={{...iconStyle, color: "#ffc107"}} title="Pending" />
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseDetails}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
}

export default DocumentViewList;

// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import DashNavbar from "./DashNavbar";
// import Sidebar from "./Sidebar";
// import Pagination from "react-bootstrap/Pagination";
// import Modal from "react-bootstrap/Modal";
// import { FcCancel, FcApproval } from "react-icons/fc";
// import { IoWarningOutline } from "react-icons/io5";
// import Spinner from "react-bootstrap/Spinner"; // Import Spinner for loading indicators

// function DocumentViewList() {
//   const [documents, setDocuments] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [filteredDocuments, setFilteredDocuments] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [selectedDocument, setSelectedDocument] = useState(null);
//   const itemsPerPage = 5;
//   const [isLoading, setIsLoading] = useState(false);
//   const [viewLoading, setViewLoading] = useState({});
//   const [buttonLoading, setButtonLoading] = useState({});

//   useEffect(() => {
//     fetchDocuments();
//   }, [currentPage, searchTerm]);

//   const fetchDocuments = async () => {
//     setIsLoading(true); // Start loading
//     try {
//       const response = await axios.get(
//         `https://raasbackend.vetrinahealthcare.com/api/documents/?page=${currentPage}`
//       );
//       setDocuments(response.data);
//       filterDocuments(response.data);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     } finally {
//       setIsLoading(false); // Stop the loading spinner
//     }
//   };

//   const filterDocuments = (data) => {
//     const filtered = data.filter(
//       (document) =>
//         document.username.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         document.email.toLowerCase().includes(searchTerm.toLowerCase())
//     );
//     setFilteredDocuments(filtered);
//   };

//   const handlePageChange = (page) => {
//     if (page < 1 || page > totalPages) {
//       return;
//     }
//     setCurrentPage(page);
//   };

//   const totalPages = Math.ceil(filteredDocuments.length / itemsPerPage);
//   const paginatedDocuments = filteredDocuments.slice(
//     (currentPage - 1) * itemsPerPage,
//     currentPage * itemsPerPage
//   );

//   const handleSearch = (e) => {
//     setSearchTerm(e.target.value);
//     setCurrentPage(1);
//   };

//   const handleViewDetails = (document) => {
//     setSelectedDocument(document);
//   };

//   const handleCloseDetails = () => {
//     setSelectedDocument(null);
//   };

//   const handleOpenDocument = async (documentType) => {
//     setViewLoading((prev) => ({ ...prev, [documentType]: true }));
//     try {
//       const response = await axios.post(
//         "https://raasbackend.vetrinahealthcare.com/api/view_document/",
//         { email: selectedDocument.email, document_type: documentType },
//         { responseType: "blob" }
//       );

//       const url = window.URL.createObjectURL(
//         new Blob([response.data], { type: "application/pdf" })
//       );
//       window.open(url, "_blank");
//     } catch (error) {
//       console.error("Error opening document:", error);
//     } finally {
//       setViewLoading((prev) => ({ ...prev, [documentType]: false }));
//     }
//   };

//   const handleAcceptReject = async (documentType, status) => {
//     setButtonLoading((prev) => ({
//       ...prev,
//       [`${documentType}_${status}`]: true,
//     }));

//     try {
//       await axios.post(
//         "https://raasbackend.vetrinahealthcare.com/api/update_document_status/",
//         {
//           email: selectedDocument.email,
//           document_type: documentType,
//           status: status,
//         }
//       );

//       setSelectedDocument((prev) => ({
//         ...prev,
//         [`${documentType}_status`]: status,
//       }));

//       fetchDocuments();
//     } catch (error) {
//       console.error("Error updating status:", error);
//     } finally {
//       setButtonLoading((prev) => ({
//         ...prev,
//         [`${documentType}_${status}`]: false,
//       }));
//     }
//   };

//   const iconStyle = { fontSize: "200%" };

//   return (
//     <>
//       <DashNavbar />
//       <div className="wrapper">
//         <Sidebar />
//         <div className="main">
//           <div className="container" style={{ marginTop: "25px" }}>
//             <div
//               className="auth-inner mt-2 w-100"
//               style={{ padding: "10px 10px 10px 10px" }}
//             >
//               <h2 className="mb-4 gradient-text">Document View List</h2>
//               <div className="input-group justify-content-center align-items-center">
//                 <div className="form-outline w-50">
//                   <input
//                     type="search"
//                     className="form-control"
//                     placeholder="Search by Name or Email"
//                     value={searchTerm}
//                     onChange={handleSearch}
//                   />
//                   <button className="btn btn-primary searchicon text-xs">
//                     <i className="fas fa-search"></i>
//                   </button>
//                 </div>
//               </div>
//               <div className="table-responsive">
//                 <table className="table">
//                   <thead className="thead-dark">
//                     <tr>
//                       <th scope="col">Sr.No</th>
//                       <th scope="col">Name</th>
//                       <th scope="col">Email</th>
//                       <th scope="col">Actions</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {isLoading ? (
//                       <tr>
//                         <td colSpan="4" className="text-center">
//                           <div className="spinner-border text-primary" role="status">
//                             <span className="sr-only">Loading...</span>
//                           </div>
//                         </td>
//                       </tr>
//                     ) : paginatedDocuments.length > 0 ? (
//                       paginatedDocuments.map((document, index) => (
//                         <tr key={index}>
//                           <td>{index + 1}</td>
//                           <td>{document.username}</td>
//                           <td>{document.email}</td>
//                           <td>
//                             <button
//                               className="btn btn-primary btn-sm"
//                               onClick={() => handleViewDetails(document)}
//                             >
//                               View
//                             </button>
//                           </td>
//                         </tr>
//                       ))
//                     ) : (
//                       <tr>
//                         <td colSpan="4" className="text-center">
//                           No documents found.
//                         </td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>

//               <div className="d-flex justify-content-start mt-4">
//                 <Pagination>
//                   <Pagination.Prev
//                     onClick={() => handlePageChange(currentPage - 1)}
//                     disabled={currentPage === 1}
//                   />
//                   {Array.from({ length: totalPages }, (_, index) => (
//                     <Pagination.Item
//                       key={index + 1}
//                       active={index + 1 === currentPage}
//                       onClick={() => handlePageChange(index + 1)}
//                     >
//                       {index + 1}
//                     </Pagination.Item>
//                   ))}
//                   <Pagination.Next
//                     onClick={() => handlePageChange(currentPage + 1)}
//                     disabled={currentPage === totalPages}
//                   />
//                 </Pagination>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       {selectedDocument && (
//         <Modal show={true} onHide={handleCloseDetails} size="lg">
//           <Modal.Header closeButton>
//             <Modal.Title>
//               {selectedDocument.username} ({selectedDocument.email})
//             </Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             <table className="table">
//               <thead>
//                 <tr>
//                   <th scope="col">Document Name</th>
//                   <th scope="col">View PDF</th>
//                   <th scope="col">Action</th>
//                   <th scope="col">Status</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {["aadhar", "pan", "hsc", "ssc", "degree", "other"].map((docType) => (
//                   <tr key={docType}>
//                     <td>{docType.toUpperCase()}</td>
//                     <td>
//                       <button
//                         className="btn btn-primary btn-sm"
//                         onClick={() => handleOpenDocument(docType)}
//                         disabled={!selectedDocument[docType] || viewLoading[docType]}
//                       >
//                         {viewLoading[docType] ? <Spinner size="sm" /> : "View PDF"}
//                       </button>
//                     </td>
//                     <td>
//                       <button
//                         className="me-2 btn btn-success btn-sm"
//                         onClick={() => handleAcceptReject(docType, "Y")}
//                         disabled={
//                           !selectedDocument[docType] ||
//                           buttonLoading[`${docType}_Y`]
//                         }
//                       >
//                         {buttonLoading[`${docType}_Y`] ? (
//                           <Spinner size="sm" />
//                         ) : (
//                           "Accept"
//                         )}
//                       </button>
//                       <button
//                         className="me-2 btn btn-danger btn-sm"
//                         onClick={() => handleAcceptReject(docType, "N")}
//                         disabled={
//                           !selectedDocument[docType] ||
//                           buttonLoading[`${docType}_N`]
//                         }
//                       >
//                         {buttonLoading[`${docType}_N`] ? (
//                           <Spinner size="sm" />
//                         ) : (
//                           "Reject"
//                         )}
//                       </button>
//                     </td>
//                     <td>
//                       {selectedDocument[`${docType}_status`] === "Y" && (
//                         <FcApproval style={iconStyle} />
//                       )}
//                       {selectedDocument[`${docType}_status`] === "N" && (
//                         <FcCancel style={iconStyle} />
//                       )}
//                       {!selectedDocument[`${docType}_status`] && (
//                         <IoWarningOutline style={iconStyle} />
//                       )}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </Modal.Body>
//         </Modal>
//       )}
//     </>
//   );
// }

// export default DocumentViewList;


